import React from 'react';
import { useSelector } from 'react-redux';
import { MetrovacesaEligeTuLook, MetrovacesaLogoShort } from '../../shared/svg/components';

const Header = () => {
  const settings = useSelector(state => state.configurator.settings);
  return (
    <div className="header-container">
      <div className="logo-container">
        <div className="logo"><MetrovacesaEligeTuLook /></div>
        <div className="logo-mobile"><MetrovacesaLogoShort /></div>
      </div>
      <div className={`container-client-promotion${settings.name.length > 23 ? ' long-name' : ''}`}>
        <div className="promotion">{settings.name}</div>
        <div className="expiry-date">Fecha límite: {settings.promotion_end_date}</div>
      </div>
      { /* <div className="main-title">
        {settings.projectName}
      </div>
      <div className="menu-button" />
      */}
    </div>
  );
};

export default Header;
